import { render, staticRenderFns } from "./RatingCardArtist.vue?vue&type=template&id=eb26b79c&scoped=true"
import script from "./RatingCardArtist.vue?vue&type=script&lang=js"
export * from "./RatingCardArtist.vue?vue&type=script&lang=js"
import style0 from "./RatingCardArtist.vue?vue&type=style&index=0&id=eb26b79c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb26b79c",
  null
  
)

export default component.exports